import { AppMode, BetbyBonusBehavior, CatalogFilter, EndpointType, Theme } from '../types.js';
const themeSetting = {
    theme: Theme.Generic,
    rankConfig: { sublevelFormat: 'roman', sublevelImages: true },
    betbyEnabled: true,
    betbyBonusBehavior: BetbyBonusBehavior.NoBonusMoney,
    betbyThemeName: 'flush',
    brand: 'casino.com',
    brandTitle: 'Casino',
    canonicalUrl: 'https://casino.com',
    cdnBase: 'https://cdn.gmcdn.org',
    cdnBaseFallbacks: ['https://flush.gmcdn.org'],
    cdnTiles: 'https://tiles.flush.com',
    cdnBanners: 'https://images.flush.com/',
    cubePayEnabled: true,
    discordLink: 'https://discord.gg/NMsaxDF3Yu',
    googleAnalytics: 'G-PP80PE9SH9',
    googleClientId: '1030216308308-9ceh2uirt0ltfdb0duunbmg83kp41s9a.apps.googleusercontent.com',
    // googleClientId: '789939130685-qapegigbhg77v6ngmahi8ulp6vpkpn44.apps.googleusercontent.com',
    googleTagManager: 'GTM-KK6X2SQT',
    languageDefault: 'en',
    languages: ['en', 'cs', 'de', 'es', 'fr', 'it', 'ja', 'ko', 'pt', 'ru', 'zh'],
    languagesTiles: ['ja', 'ko'],
    languagesAutoAccept: ['en', 'cs', 'de', 'es', 'fr', 'it', 'ja', 'ko', 'pt', 'ru', 'zh'],
    intercomId: 'me2zqgio',
    racesEnabled: false,
    supportEmail: 'support@generic.com',
    telegramLink: 'https://t.me/',
    xLink: 'https://x.com/',
    noIndex: false,
    themePath: 'casino',
    verbiageLabel: 'casino',
    ui: {
        mobileMenu: {
            mobileMenuStyle: 'default',
            useMenuItemIndicator: true
        },
        accordion: {
            accordionStyle: 'flat-neutral'
        },
        auth: {
            useSolidAccentOAuthButton: false,
            showWalletConnect: false,
            useTightModalBodyPadding: false,
            useOffsetModalCloseButton: true,
            useAuthHeroBanner: true
        },
        background: {
            backgroundStyle: 'solid-dark'
        },
        bannerSwiper: {
            bannerSwiperStyle: 'default',
            useFlatNeutralPagination: true
        },
        cardSwiper: {
            cardSwiperStyle: 'default',
            viewAllAsButton: false,
            showNavigationArrows: true,
            disableEdgeMask: false
        },
        button: {
            buttonStyle: 'solid',
            useUppercaseAsDefault: false
        },
        betby: {
            betslipBottom: 60,
            customUI: false
        },
        betfeed: {
            betfeedStyle: 'default',
            usedVerbiage: 'bet_feed',
            enableWeeklyRaceTab: true
        },
        cashier: {
            useAcceptDeclineBonusType: true,
            withdrawOnlyUsdt: false,
            withdrawOnlyUsdtMemeCoins: true,
            useInfoStateForWarnings: true,
            showConversionRateDeposit: false,
            showProgressBarBonusMoney: true,
            useBuyCryptoIFrame: false,
            buyCryptoMaxAmount: 500,
            buyCryptoMinAmount: 15,
            showQrCodeBuyCrypto: false,
            useSearchInputOnCryptoDropdown: false,
            showImageOnDepositBonusOffers: false,
            depositBonusVerbiage: 'casino_bonus',
            depositBonusWageringContributions: [
                { category: 'slots', percentage: 100 },
                { category: 'live_casino', percentage: 10 },
                { category: 'originals', percentage: 5 },
                { category: 'table_games', percentage: 10 }
            ],
            showWithdrawalWarningIfNoFunds: false,
            showWithdrawalPlayRequirementImmediately: true,
            cashierStyle: 'default',
            useCashierHomeScreen: false,
            useSidetabs: true,
            buyCryptoEnabled: true,
            useCashierV4: true,
            useCompactDepositAddressOptionLayout: false,
            extendCashierVerbiageKeysWithBrandLabel: true,
            useVerificationStep: false,
            useFlatNeutralDepositCta: true,
            useAlternative2HomeCards: true,
            useNeutralAssetPaths: true
        },
        casinoLobby: {
            casinoLobbyStyle: 'default',
            showLiveWins: false,
            useGenericOriginalsProviderLabel: true
        },
        chat: {
            chatStyle: 'flat-neutral',
            requiredLanguageVerbiage: 'english'
        },
        checkbox: {
            useAlternativeTick: false,
            checkboxStyle: 'flat-neutral'
        },
        dropdown: {
            dropdownStyle: 'flat-neutral',
            useDropdownBackgroundImage: false
        },
        emailVerify: {
            emailVerifyStyle: 'default'
        },
        footer: {
            footerStyle: 'default',
            useEmbeddedShellDecor: false
        },
        games: {
            showRacesLeaderboard: true,
            showNavigationOnMobile: true,
            showLikeButton: true,
            showLogoWhenPlayingDesktop: true,
            showGameInfoModalOnGamePathMobile: true,
            useFlatNeutralGameInfoModal: true,
            applyPedestalIllustrationHueShift: true,
            useCompactRacesLeaderboardInfoBackdrop: true,
            showRacesLeaderboardPerimeterIllustrations: false,
            useNeutralAssetPaths: true
        },
        header: {
            headerStyle: 'default',
            buttonLoginVariant: 'tertiary',
            useTightRewardsToggleHorizontalPadding: false,
            useFlatNeutralRewardsButton: true,
            useFlatNeutralSurface: true,
            useFlatNeutralWallet: true,
            useSimpleVipButton: true,
            useFlatNeutralRakeboostButton: true
        },
        helpdesk: {
            useDynamicBonusTerms: false
        },
        home: {
            homeStyle: 'alternative',
            showBuyCryptoBanner: true,
            showLiveWins: true,
            cryptoBannerStyle: 'default',
            buyCryptoBannerArtStyle: 'framed-chips',
            useAlternateOriginalsCategoryTitle: true,
            showAdventCalendarPage: false,
            useNeutralAssetPaths: true
        },
        icons: {
            vipHeaderGlyphDarkFill: false,
            statusIconsUseWarmPalette: false,
            expandSectionToggleUsesMintAccent: false,
            navIconPickerAllowRemoteAssets: true,
            navIconPickerUseBundledIconFactories: false
        },
        infoCard: {
            infoCardStyle: 'solid-neutral'
        },
        input: {
            inputStyle: 'flat-neutral'
        },
        layout: {
            layoutStyle: 'default',
            isContrastTextColor: false,
            useCompactVerticalPagePadding: true,
            useReducedMarginsInHomePage: true,
            useCurrentColorSidebar: false,
            useReferralIconAnimated: true,
            useNewIcons: false,
            useRemoteIcons: false,
            showCryptoPriceDropdown: false,
            showNotInCatalogGames: false,
            showUpdownGameDropdown: false,
            useV2LiveWins: false,
            useReferralBannerOnlyImageCustom: false,
            usePromoItemContentCustom: false,
            useCentralButtonOnMobileMenu: false,
            selectedCentralButton: 'rewards',
            centralButtonDepositThresholdUsd: 20,
            sectionIconSize: 24,
            useExpandedRankPresentation: true,
            useAlternateMobileSidebarBackdrop: false,
            embedWebSiteOrganizationJsonLd: false
        },
        liveWins: {
            liveWinsStyle: 'default',
            usedVerbiage: 'big_wins',
            useSpecialWinCards: true,
            useFlatNeutralBigWinCards: true
        },
        loading: {
            useLottie: false,
            publicInitPageLoadDisplayFor: 0,
            playerInitPageLoadDisplayFor: 3000,
            useCustomLoading: true,
            useSubtleLogoAnimation: true
        },
        maintenance: {
            maintenanceStyle: 'default',
            contentSource: 'hardcoded'
        },
        geoblock: {
            contentSource: 'hardcoded'
        },
        modal: {
            modalStyle: 'flat-neutral'
        },
        walletDropdown: {
            showBalancePreferenceToggles: true
        },
        notifications: {
            notificationsStyle: 'default',
            useBorderedPlayerNotificationsIcon: true,
            useGradientPublicNotificationsIcon: true,
            useExtendedDepositNotificationTitles: false,
            useFlatNeutralPanel: true
        },
        toasts: {
            toastsStyle: 'default',
            isLocalIcon: false
        },
        tooltip: {
            tooltipStyle: 'default'
        },
        profileModal: {
            profileModalStyle: 'default',
            showFavouriteSection: true,
            useStarsBackgroundOnFavouriteToken: false,
            useTokenArtBackgroundOnDesktop: true,
            useCompactFavouriteTokenMobileCard: true,
            useFlatNeutralProfileAccents: true
        },
        promotions: {
            showExpiredPromotions: true,
            useAspectRatioBoxDetailCustom: false,
            promoBannerStyle: 'default',
            promotionsStyle: 'default',
            showActionButton: true,
            highlightTitleFirstWord: false,
            useFlatNeutralStatusBadges: true
        },
        provider: {
            providerStyle: 'default',
            useSolidPrimaryGameCountBadge: true,
            useFlatNeutralCard: true,
            useNeutralAssetPaths: true
        },
        referral: {
            referralDashboardBannerType: 'html',
            showContainerInFAQ: true,
            faqTitleStyle: 'badge',
            faqVisibilityPreset: 'all',
            accordionGlassStyle: false,
            showAboutPageDecorativeGradients: false,
            rulesCardsStyle: 'illustrated',
            rulesFootnoteMuted: false,
            highlightStepTitles: false,
            rankProgressPalette: 'cool',
            usePrefixedVerbiageKeys: true,
            shareModalStyle: 'rich',
            shareMessageVariant: 'campaign',
            shareBannerStyle: 'classic',
            referralDashboardBannerStyle: 'classic',
            useNeutralAssetPaths: true,
            useFlatNeutralProgressCard: true
        },
        transparency: {
            enabled: true,
            useFlatNeutralProgressBar: true
        },
        affiliates: {
            enabled: false,
            usePrefixedVerbiageKeys: true,
            useNeutralAssetPaths: true
        },
        rewardsDropdown: {
            rewardsDropdownStyle: 'flat-neutral',
            useComfortableRewardsTimerLabels: false,
            showSeasonalRewardsCampaignTabs: false,
            useNeutralAssetPaths: true
        },
        seoText: {
            style: 'default'
        },
        settings: {
            settingsStyle: 'default'
        },
        sidebar: {
            sidebarStyle: 'alternative',
            showLuckyDip: false,
            showBanner: false,
            useFlatNeutralSurface: true,
            useFlatNeutralIconFill: true
        },
        table: {
            tableStyle: 'default'
        },
        tabs: {
            tabsStyle: 'default',
            useCompactTabStripRadius: true,
            tabButtonsDefaultVariant: 'secondary',
            useFlatNeutralSurface: true,
            useFlatNeutralActiveTab: true
        },
        text: {
            successTextUsesWarmTone: false
        },
        toggle: {
            toggleStyle: 'flat-neutral'
        },
        topSection: {
            casinoTopSectionStyle: 'default',
            highlightTitleFirstWord: false
        },
        transactions: {
            transactionsStyle: 'default',
            useSegmentedTabs: false,
            useElevatedRows: false,
            showEmptyStateIllustration: false
        },
        vip: {
            vipDashboardStyle: 'default',
            vipAboutStyle: 'default',
            vipAboutStylePreview: 'default',
            useMarkdownFaqs: true,
            heroCardOpacity: 0.9,
            rewardsTableLayout: 'detailed',
            rewardsProgressPalette: 'cool',
            useFlatNeutralRewardCards: true,
            includeWageringRequirementRow: false,
            reorderPrimaryBenefitCards: false,
            testimonialsHeaderStyle: 'badge',
            useCompactTestimonialsCardHeight: false,
            faqListLength: 'full',
            usePrefixedVerbiageKeys: true,
            assetSet: 'classic',
            negativeBadgeTone: 'coral',
            showRankPrefixBeforeDisplayName: false,
            usePrimaryNextRanksAccent: true,
            useAccentPendingTotalsBadge: true,
            useBorderOnMiniVipCalendarCard: true,
            useCompactClubOverviewSectionHeights: true,
            useCompactRoyaltyBannerTypography: true,
            useExpandedRoyaltyBannerSectionSpacing: true,
            useGradientVipCalendarDateHeader: true,
            useTallerRoyaltyBannerOnNarrowScreens: true,
            showRoyaltyBannerInDashboard: false,
            calendarSummaryLabel: 'claimed',
            includeRaceInRakebackBreakdown: false,
            showVipRewardTooltips: false,
            monthlyRewardsTooltipStyle: 'compact',
            useClassicVipCalendarCardChrome: false,
            rakeboostProgressTone: 'accent',
            useNeutralAssetPaths: true
        },
        profileDropdown: {
            showSupport: false,
            profileDropdownStyle: 'flat-neutral'
        },
        activeEventTheme: {
            eventID: 'christmas2025',
            eventStartDate: '2025-11-21T00:00:00Z',
            eventEndDate: '2025-12-31T23:59:59Z',
            config: {
                pageBackground: false,
                buttonAddon: true,
                navbarBackground: true,
                sidebarBackground: true,
                divider: true,
                customLogo: true
            }
        }
    }
};
const genericCanonicalHelpcenterHref = `${themeSetting.canonicalUrl}/helpcenter`;
const themeSettings = [
    {
        ...themeSetting,
        brand: 'gamma.casino.com',
        helpcenterHref: genericCanonicalHelpcenterHref,
        fingerprintjsHost: 'fp.casino.com',
        languages: [
            'ar',
            'cs',
            'de',
            'en',
            'es',
            'fr',
            'id',
            'it',
            'ja',
            'ko',
            'ms',
            'pt',
            'ru',
            'tr',
            'vi',
            'zh'
        ],
        languagesTiles: ['ja', 'ko', 'tr'],
        betbyEnabled: true,
        noIndex: true
    },
    {
        ...themeSetting,
        brand: 'alpha-generic.previewenv.net',
        languages: [
            'ar',
            'cs',
            'de',
            'en',
            'es',
            'fr',
            'id',
            'it',
            'ja',
            'ko',
            'ms',
            'pt',
            'ru',
            'tr',
            'vi',
            'zh'
        ],
        languagesTiles: ['ja', 'ko', 'tr'],
        noIndex: true
    },
    {
        ...themeSetting,
        brand: 'localhost',
        languages: ['en', 'cs', 'de', 'es', 'fr', 'it', 'ja', 'ko', 'pt', 'ru', 'zh'],
        noIndex: true
    }
];
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getThemeSetting = (domain, fullDomain) => {
    return themeSettings.find((s) => fullDomain.includes(s.brand)) ?? themeSetting;
};
export const endpointSettings = [];
// todo: read alt endpoints from S3, get player endpoints from authentication
export const endpointSetting = (appMode, domain, // eslint-disable-line @typescript-eslint/no-unused-vars
fullDomain) => {
    switch (fullDomain) {
        case 'gamma.flush.com':
        case 'preview.flush.com':
        case 'next.flush.com':
            return {
                name: 'casino',
                theme: Theme.Generic,
                betbyBrandId: '2511187282057371656',
                betbyEnabled: true,
                betbyScriptUrl: 'https://flush.sptpub.com/bt-renderer.min.js',
                base: 'monopoly-flush.prod.infinitro.dev',
                baseCurrency: 'USD',
                baseCurrencySymbol: '$',
                baseCurrencyDigits: 2,
                realm: 'prod-flush',
                catalogFilter: CatalogFilter.ReleaseGames,
                endpointType: EndpointType.Production,
                reownProjectId: '441421829a4cc3f2eaf2cccd9a34afff'
            };
        case 'stable.flush.com':
            return {
                name: 'casino',
                theme: Theme.Generic,
                betbyBrandId: '2511187282057371656',
                betbyEnabled: true,
                betbyScriptUrl: 'https://flush.sptpub.com/bt-renderer.min.js',
                base: 'monopoly-flush.prod.infinitro.dev',
                baseCurrency: 'USD',
                baseCurrencySymbol: '$',
                baseCurrencyDigits: 2,
                realm: 'prod-flush',
                catalogFilter: CatalogFilter.ReleaseGames,
                endpointType: EndpointType.Production,
                reownProjectId: '441421829a4cc3f2eaf2cccd9a34afff'
            };
    }
    switch (appMode) {
        case AppMode.Player:
            return {
                name: 'casino',
                theme: Theme.Generic,
                betbyBrandId: '2511187282057371656',
                betbyEnabled: true,
                betbyScriptUrl: 'https://flush.sptpub.com/bt-renderer.min.js',
                base: 'monopoly-flush.prod.infinitro.dev',
                baseCurrency: 'USD',
                baseCurrencySymbol: '$',
                baseCurrencyDigits: 2,
                realm: 'prod-flush',
                catalogFilter: CatalogFilter.ReleaseGames,
                endpointType: EndpointType.Production,
                reownProjectId: '441421829a4cc3f2eaf2cccd9a34afff'
            };
    }
    return {
        name: 'casino',
        theme: Theme.Generic,
        betbyBrandId: '2511187282057371656',
        betbyEnabled: true,
        betbyScriptUrl: 'https://flush.sptpub.com/bt-renderer.min.js',
        base: 'fc133b1e-d9fa-4f82-8ea6-ab4b8bd06814.api-access.org',
        baseCurrency: 'USD',
        baseCurrencySymbol: '$',
        baseCurrencyDigits: 2,
        realm: 'prod-flush',
        catalogFilter: CatalogFilter.ReleaseGames,
        endpointType: EndpointType.Production,
        reownProjectId: '441421829a4cc3f2eaf2cccd9a34afff'
    };
};
export { themeSetting as genericThemeSetting, themeSettings as genericThemeSettings };
